const convertMegaMenu = (menu, numberCol) => {
    if (numberCol < 1)
        return;
    const newArr = menu.children.map((m) => {
        return {
            len: m.children.length + 1,
            column: [Object.assign({}, m)],
        };
    });
    if (newArr.length <= numberCol)
        return newArr;
    newArr.sort((a, b) => b.len - a.len);
    const result = [...newArr.slice(0, numberCol)];
    let min;
    let k;
    for (let i = numberCol; i < newArr.length; i++) {
        min = result[0].len;
        k = 0;
        for (let j = 0; j < numberCol; j++) {
            if (min > result[j].len) {
                min = result[j].len;
                k = j;
            }
        }
        result[k] = {
            len: result[k].len + newArr[i].len,
            column: [...result[k].column, ...newArr[i].column],
        };
    }
    return result;
};

export { convertMegaMenu };
